export { default as adbook } from '#components/adbook/js/adbook.js'
export { default as ads } from '#components/ads/js/ads.js'
export { default as app } from '#components/app/js/app.js'
export { default as auth } from '#components/auth/js/auth.js'
export { default as calendar } from '#components/calendar/js/calendar.js'
export { default as chat } from '#components/chat/js/chat.js'
export { default as credit } from '#components/credit/js/credit.js'
export { default as designsystem } from '#components/designsystem/js/designsystem.js'
export { default as docs } from '#components/docs/js/docs.js'
export { default as generics } from '#components/generics/js/generics.js'
export { default as mail } from '#components/mail/js/mail.js'
export { default as pages } from '#components/pages/js/pages.js'
export { default as space } from '#components/space/js/space.js'
export { default as www } from '#components/www/js/www.js'
export { default as default2020 } from '#skins/default2020/js/default2020.js'
export { default as junior2010 } from '#skins/junior2010/js/junior2010.js'
export { default as kid2010 } from '#skins/kid2010/js/kid2010.js'
